export default "__VITE_ASSET__DGQ14xSF__"